export default __webpack_public_path__ + "static/8_highflyer-hurrincanrana-eefa980f9170ab79e3d66fda1d530cbe.png";